import { RestServiceUtils } from "../utils/RestServiceUtils";

const deviceService = {
    addScreens: (screenIds, organizationId, placeId) => {
        const URL = `/ums/${organizationId}/${placeId}/screens`;
        return RestServiceUtils.HTTP_POST(URL, screenIds, {}, false);
    },

    getScreensDetails: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/screens`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    deleteScreens: (organizationId, placeId, screenIds) => {
        const URL = `/ums/${organizationId}/${placeId}/screens`;
        return RestServiceUtils.HTTP_DELETE(URL, screenIds);
    },

    assignTagToScreens: (organizationId, placeId, screenId, tagId) => {
        const URL = `/ums/${organizationId}/${placeId}/screens/addTag`;
        const payload = { screenId, tagId, };
        return RestServiceUtils.HTTP_POST(URL, payload);
    },

    removeTagFromScreens: (organizationId, placeId, screenId) => {
        const URL = `/ums/${organizationId}/${placeId}/screens/removeTag`;
        return RestServiceUtils.HTTP_DELETE(URL, { screenId });
    }
};

export default deviceService;
